<template>
  <div class="mini-sync">
    <button
      class="mini-sync__btn"
      :class="{ 'is-loading': loading }"
      :disabled="loading"
      @click="genAndJump"
    >
      {{ loading ? '跳转中...' : '前往微信小程序' }}
    </button>
    <p v-if="errorMsg" class="mini-sync__error">{{ errorMsg }}</p>
  </div>
</template>

<script>
import "@/utils/flexible";
import WechatApi from "@/api/wechat";

export default {
  name: "MiniSync",
  data() {
    return {
      loading: false,
      errorMsg: "",
      // trial=体验版，正式上线改为 release
      envVersion: "trial", // "trial", "develop", "release"
    };
  },
  methods: {
    // 取 APP 透传过来的原始 query 串（去掉开头的 ? / &）
    // 不对参数做任何重命名、裁剪、重组：拿到什么就原样传给小程序
    getRawQuery() {
      let search = window.location.search || "";
      if (!search) {
        // hash 路由兜底：/#/up/mini-sync?xxx=xxx
        const qIndex = (window.location.hash || "").indexOf("?");
        if (qIndex > -1) search = window.location.hash.slice(qIndex);
      }
      return search.replace(/^[?&]+/, "");
    },
    async genAndJump() {
      this.href = location.href;
      if (this.loading) return;
      this.loading = true;
      this.errorMsg = "";
      try {
        const query = this.getRawQuery();
        if (!query) {
          this.errorMsg = "参数缺失，请重试；或者请联系客服";
          return;
        }

        const params = {
          // 绑定目标页：
          //   pages/views/bind/index 为新增页，需随版本发布后才能用（未发布会报 invalid weapp pagepath）
          //   联调期先用线上已存在的 pages/index/index 中转（其 onLoad 会接管绑定流程）
          path: "pages/views/bind/index",
          query,
          env_version: this.envVersion,
          is_expire: 0,
        };
        // res 为后端 body：{ code, status, message, data }
        const res = await WechatApi.generateScheme(params);
        if ((res.code == 0 || res.status == "success") && res.data) {
          const openlink = res.data.openlink || res.data.scheme || res.data.url || res.data;
          // APP 内嵌 WebView 会拦截 weixin:// 协议唤起小程序
          window.location.href = openlink;
        } else {
          this.errorMsg = (res && res.message) || "跳转失败，请重试";
        }
      } catch (e) {
        this.errorMsg = "跳转失败，请重试";
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/sass/global.scss";

.mini-sync {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 32px;
  box-sizing: border-box;
  background: #f5f6f7;

  &__btn {
    width: 100%;
    height: 50px;
    border-radius: 25px;
    background: linear-gradient(90deg, #ff7c45 0%, #ff0909 100%);
    color: #fff;
    font-size: 17px;
    font-weight: 500;
    border: none;
    outline: none;
    cursor: pointer;

    &.is-loading {
      opacity: 0.6;
    }
  }

  &__error {
    margin-top: 16px;
    font-size: 13px;
    color: #ff0909;
    line-height: 20px;
    text-align: center;
  }
}
</style>
